// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as PromotionEditDiscountedProduct from "./PromotionEditDiscountedProduct.res.js";

let RootCampaign = {};

function get(values, field) {
  switch (field) {
    case "DiscountedProducts" :
      return values.discountedProducts;
    case "Name" :
      return values.name;
    case "PriceName" :
      return values.priceName;
    case "Period" :
      return values.period;
    case "RootCampaigns" :
      return values.rootCampaigns;
  }
}

function set(values, field, value) {
  switch (field) {
    case "DiscountedProducts" :
      return {
        discountedProducts: value,
        name: values.name,
        priceName: values.priceName,
        period: values.period,
        rootCampaigns: values.rootCampaigns
      };
    case "Name" :
      return {
        discountedProducts: values.discountedProducts,
        name: value,
        priceName: values.priceName,
        period: values.period,
        rootCampaigns: values.rootCampaigns
      };
    case "PriceName" :
      return {
        discountedProducts: values.discountedProducts,
        name: values.name,
        priceName: value,
        period: values.period,
        rootCampaigns: values.rootCampaigns
      };
    case "Period" :
      return {
        discountedProducts: values.discountedProducts,
        name: values.name,
        priceName: values.priceName,
        period: value,
        rootCampaigns: values.rootCampaigns
      };
    case "RootCampaigns" :
      return {
        discountedProducts: values.discountedProducts,
        name: values.name,
        priceName: values.priceName,
        period: values.period,
        rootCampaigns: value
      };
  }
}

let Lenses_ = {
  get: get,
  set: set
};

let Lenses = {
  get: get,
  set: set
};

let include = Form.Make(Lenses);

let schema = [
  {
    TAG: "StringNotEmpty",
    _0: "Name"
  },
  {
    TAG: "Custom",
    _0: "Period",
    _1: param => {
      if (Stdlib_Option.isSome(param.period)) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("Please select a date range.")
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "PriceName",
    _1: param => {
      let priceName = param.priceName;
      if (priceName !== undefined && priceName !== "") {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("Please select a price name.")
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "RootCampaigns",
    _1: param => {
      if (param.rootCampaigns.some(campaign => campaign.selected)) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("Please select at least one shop.")
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "DiscountedProducts",
    _1: param => {
      let selectedPriceName = param.priceName;
      let discountedProducts = param.discountedProducts;
      if (discountedProducts.length !== 0) {
        if (discountedProducts.every(product => PromotionEditDiscountedProduct.isValid(product, selectedPriceName))) {
          return {
            TAG: "Ok",
            _0: undefined
          };
        } else {
          return {
            TAG: "Error",
            _0: "At least one product has an invalid discount."
          };
        }
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("Please add at least one product.")
        };
      }
    }
  }
];

let Core = include.Core;

let Schema = include.Schema;

let FormLegacyProvider = include.FormLegacyProvider;

let FormProvider = include.FormProvider;

let InputText = include.InputText;

let InputSuggestionComboBox = include.InputSuggestionComboBox;

let InputSelect = include.InputSelect;

let InputToggleButtonGroup = include.InputToggleButtonGroup;

let InputCountrySelect = include.InputCountrySelect;

let InputTextArea = include.InputTextArea;

let InputPassword = include.InputPassword;

let InputNumber = include.InputNumber;

let InputOptionalNumber = include.InputOptionalNumber;

let InputRadioGroup = include.InputRadioGroup;

let InputRadioCardGroup = include.InputRadioCardGroup;

let InputPhone = include.InputPhone;

let InputCheckbox = include.InputCheckbox;

let InputToggleSwitch = include.InputToggleSwitch;

let InputDate = include.InputDate;

let InputOptionalDate = include.InputOptionalDate;

let InputOptionalDateFastNav = include.InputOptionalDateFastNav;

let InputDateRange = include.InputDateRange;

let CancelButton = include.CancelButton;

let SubmitButton = include.SubmitButton;

let ControlEnterKey = include.ControlEnterKey;

let AutoSave = include.AutoSave;

let useFormPropState = include.useFormPropState;

let useField = include.useField;

let useFormState = include.useFormState;

let useFormDispatch = include.useFormDispatch;

let validate = include.validate;

let isValidField = include.isValidField;

export {
  RootCampaign,
  Lenses_,
  Lenses,
  Core,
  Schema,
  FormLegacyProvider,
  FormProvider,
  InputText,
  InputSuggestionComboBox,
  InputSelect,
  InputToggleButtonGroup,
  InputCountrySelect,
  InputTextArea,
  InputPassword,
  InputNumber,
  InputOptionalNumber,
  InputRadioGroup,
  InputRadioCardGroup,
  InputPhone,
  InputCheckbox,
  InputToggleSwitch,
  InputDate,
  InputOptionalDate,
  InputOptionalDateFastNav,
  InputDateRange,
  CancelButton,
  SubmitButton,
  ControlEnterKey,
  AutoSave,
  useFormPropState,
  useField,
  useFormState,
  useFormDispatch,
  validate,
  isValidField,
  schema,
}
/* include Not a pure module */
